import React from 'react';
import '@/index.css';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import {UserProvider} from "@/contexts/userContext";
import App from "@/App";
import {
    ArticleList,
    ArticleTagList,
    PollList,
    PollResults,
    ResourceList,
    EventList,
    ResourceCategoryList,
    POICategoryList, POIList, UserList, PartnerList, GuideList, GuideTypeList, StatsList, ClubList, DivisionList,
    ResetPassword
} from "@/routes";
import ModalProvider from "@/contexts/modalContext"
import {Provider} from "@/components/ui/provider";
import {Toaster} from "@/components/ui/toaster";
import LanguageProvider from "@/contexts/languageContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LanguageProvider>
        <Provider>
            <ModalProvider>
                <UserProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/reset-password" element={<ResetPassword/>}/>
                            <Route path="/" element={<App/>}>
                                <Route index element={<div/>}/>
                                <Route path="poll">
                                    <Route index element={<PollList/>}/>
                                    <Route path=":id/results" element={<PollResults/>}/>
                                </Route>
                                <Route path="article">
                                    <Route index element={<ArticleList/>}/>
                                    <Route path="tag" element={<ArticleTagList/>}/>
                                </Route>
                                <Route path="resource">
                                    <Route index element={<ResourceList/>}/>
                                    <Route path="category" element={<ResourceCategoryList/>}/>
                                </Route>
                                <Route path="event">
                                    <Route index element={<EventList/>}/>
                                </Route>
                                <Route path="poi">
                                    <Route index element={<POIList/>}/>
                                    <Route path="category" element={<POICategoryList/>}/>
                                </Route>
                                <Route path="user">
                                    <Route index element={<UserList/>}/>
                                </Route>
                                <Route path="partner">
                                    <Route index element={<PartnerList/>}/>
                                </Route>
                                <Route path="guide">
                                    <Route index element={<GuideList/>}/>
                                    <Route path="type" element={<GuideTypeList/>}/>
                                </Route>
                                <Route path="list">
                                    <Route index element={<Navigate to="/list/club" replace/>}/>
                                    <Route path="club" element={<ClubList/>}/>
                                    <Route path="division" element={<DivisionList/>}/>
                                </Route>
                                <Route path="stats">
                                    <Route index element={<StatsList/>}/>
                                </Route>
                            </Route>

                            {/* 404 NOT FOUND */}
                            <Route path="*"
                                   render={({location}) => {
                                       if (location.pathname.endsWith('.pdf')) {
                                           window.location.href = location.pathname;
                                           return null;
                                       }
                                       return <Navigate to="/"/>;
                                   }}
                            />
                        </Routes>
                    </BrowserRouter>
                    <Toaster />
                </UserProvider>
            </ModalProvider>
        </Provider>
    </LanguageProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
